import styled from 'styled-components';
import colors from '../../../assets/styles/colors';
import ReactTooltip from 'react-tooltip';

export const StepFourContainer = styled.div`
  padding: 0 60px;

  button:disabled {
    background: ${colors.grayLight};
    border: 1px solid ${colors.grayLight};
    color: ${colors.white};
  }
`;

export const StepFourHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px; /* Relleno de 10px en la parte superior */
  padding-right: 20px; /* Relleno de 20px a la derecha */
  padding-bottom: 0px; /* Relleno de 15px en la parte inferior */
  padding-left: 20px;
`;

export const StepFourHeaderTitle = styled.div``;

export const StepFourHeaderStep = styled.div`
  color: ${colors.textSecondary};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
`;

export const StepFourHeaderInfo = styled.div`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const StepFourButtonSimulation = styled.div`
  border: 1px solid ${colors.textSecondary};
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  background: ${colors.white};
  padding: 8px 32px;
  color: ${colors.textPrimary};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  transition: .2s;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const StepFourContent = styled.div`
display: flex;
flex-direction: column;
border: 2px solid ${colors.grayLight};
border-radius: 8px;
padding: 20px;
`;


export const StepFourColumn = styled.div`
  background: ${colors.white};
  border-radius: 8px;

  &:first-child {
    border: 0;
  }

  &:last-child {
    padding: 20px;
  }
`;

export const StepFourResultItem = styled.div`
  padding: 20px;
  display: flex;
  width: 100%;
`;

export const StepFourResultItemIcon = styled.div`
  width: 47px;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.background};
  border-radius: 8px;
  margin-right: 15px;
`;

export const StepFourResultBigItemIcon = styled.div`
  width: 51px;
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.background};
  border-radius: 8px;
  margin-right: 15px;
`;

export const StepFourResultItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StepFourDisplayResultLabel = styled.h6`
  color: ${colors.bgPrimary};
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
`;

export const StepFourDisplayValues = styled.div`
  margin: 30px 0;
`;

export const StepFourDisplayValuesRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;

  &:first-child {
    margin-top: 0;
  }

  span:last-child {
    font-weight: 700;
  }
`;

export const StepFourDisplayValuesRowValue = styled.span`
  font-size: 14px;
  line-height: 23px;
  color:${colors.textPrimary};
`;

export const StepFourFooter = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
`;

export const StepFourFooterButtonDefault = styled.button`
  padding: 14px 32px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.bgSecondaryLight};
  color: ${colors.bgSecondary};
  font-size: 14px;
  line-height: 21px;
  background: ${colors.white};
  transition: ease-in-out .2s;
  font-weight: 600;
  letter-spacing: 0.03em;
  min-width: 158px;

  &:hover {
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const StepFourFooterButton = styled.button`
  padding: 14px 32px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.bgSecondaryLight};
  color: ${colors.white};
  font-size: 14px;
  line-height: 21px;
  background: ${colors.bgSecondary};
  transition: ease-in-out .2s;
  font-weight: 600;
  letter-spacing: 0.03em;
  min-width: 158px;
  
  &:hover {
    background: ${colors.bgSecondaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const StepFourFooterLeftSide = styled.div``;

export const StepFourFooterRightSide = styled.div`
  display: flex;
`;

export const TooltipTitle = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
`;

export const TooltipContent = styled.div`
font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.03em;
`;

export const Tooltip = styled(ReactTooltip).attrs({
  className: "custom-tooltip",
})`
  &.custom-tooltip {
    width: 300px !important;
    padding: 13px !important;
    font-family: Montserrat !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 22px !important;
    letter-spacing: 0.03em !important;
    opacity: 1 !important;
    background-color: rgb(187, 215, 212);
  }
`;

export const InfoCircleImage = styled.img`
  margin-bottom:-3px;
  margin-left: 3px;
`;  
